/**
 * @file useBuilderLink.ts
 * @description Ссылка на раздел конструктора сайта из его панелей
 * (phase19.16 Р1-6а; uiux-builder-shell.md §4 — `builderLink` без
 * перезагрузки): «Меню шапки →», «Настройки сайта →» из шапки, подвала,
 * SEO и окна публикации. Открытая страница или экран магазина остаются —
 * человек не теряет, где был; меняется только раздел справа. Открытая
 * группа настроек (`?group=`, SB122) не переносится — только явно в `patch`.
 */

import { useCallback } from "react";
import { useSearchParams } from "react-router";

import { useCurrentContext } from "../../auth/hooks";
import { builderLink, parseSelection, type BuilderSelection } from "../../lib/site-builder/selection";

export function useBuilderLink(): (patch: Partial<BuilderSelection>) => string {
  const slug = useCurrentContext()?.shop?.slug ?? "";
  const [params] = useSearchParams();
  return useCallback(
    (patch: Partial<BuilderSelection>) => {
      const { pageId, screen } = parseSelection(params);
      return builderLink(slug, { pageId, screen, ...patch });
    },
    [params, slug],
  );
}
